import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import PedidosEscola from "./PedidosEscola";
import Pedido from "./Pedido";

export default function Index({ match }) {
  return (
    <div className="content-wrapper">
      <Switch>
        <Redirect
          exact
          from={`${match.url}/`}
          to={`${match.url}/pedidos-escola`}
        />
        <Route
          exact
          path={`${match.url}/pedidos-escola`}
          component={PedidosEscola}
        />
        <Route path={`${match.url}/pedido/:id`} component={Pedido} />
      </Switch>
    </div>
  );
}
